
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiViewGalleryGoogle as ObiViewGalleryGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-view-gallery-google.js';
 
 
 

 
 export const ObiViewGalleryGoogle = createComponent({
   react: React,
   tagName: 'obi-view-gallery-google',
   elementClass: ObiViewGalleryGoogleElement,
   events: {
     
   }
  });
 
 